import React from "react";
import moment from "moment";
import { Link } from "@reach/router";
import useBranch from "../../hooks/useBranch";
import { statusLabels, templateLabels } from "../../utils/templates";

const AsistenteRow = ({
  user,
  notifying,
  asistente,
  postAttend,
  postPayment,
  is_waitlist,
  confirmCancel,
  handleCallback,
  single_class_id,
  is_special_event,
}) => {
  const { branch } = useBranch();

  const sendWhatsApp = (telefono) => {
    telefono = String(telefono).replace("+52", "");
    window.open(`https://wa.me/521${telefono}`, "_blank");
  };

  const renderCustomerName = () => {
    if (asistente.customer && asistente.customer !== null) {
      return (
        <span>
          {asistente.customer.name} {asistente.customer.last_name}
        </span>
      );
    }
    return (
      <span>
        {asistente.name} {asistente.last_name}
      </span>
    );
  };

  const isTrialClass = () => {
    const reservation = asistente;
    const { available_class } = reservation;
    if (available_class && available_class !== null) {
      const { purchase } = available_class;
      if (purchase && purchase !== null) {
        const class_package_id = branch?.branch_id === 1 ? 19304 : 19301;
        return purchase.class_package_id === class_package_id;
      }
    }
  };

  const getLastNotication = () => {
    const { notifications } = asistente.customer || {};
    if (Array.isArray(notifications) && notifications.length > 0) {
      const single_class_notifications = notifications.filter(
        (notification) =>
          notification.single_class_id === parseInt(single_class_id)
      );
      const last_notification = single_class_notifications.sort((a, b) =>
        moment(a.createdAt).isAfter(moment(b.createdAt)) ? -1 : 1
      )[0];
      if (last_notification && last_notification !== null) {
        return last_notification;
      }
    }
  };

  const renderTrialClass = () => {
    if (isTrialClass()) {
      return (
        <span className="badge badge-pill bg-primary ms-2">
          <i className="fa fa-award me-1" /> Trial Class
        </span>
      );
    }
  };

  const renderWellhub = () => {
    if (
      asistente.wellhub_booking_number &&
      asistente.wellhub_booking_number !== null
    ) {
      return (
        <span
          className="badge badge-pill text-white ms-2"
          style={{ backgroundColor: "rgb(216, 56, 94)" }}
        >
          Wellhub
        </span>
      );
    }
  };

  const renderWhatsAppVerified = () => {
    const { whatsapp_verified } = asistente;
    if (whatsapp_verified)
      return (
        <span className="badge text-dark bg-success">
          <i className="fab fa-whatsapp" /> Verificado
        </span>
      );
  };

  const renderCustomer = () => {
    const name = renderCustomerName();
    if (["super_admin", "admin", "manager"].includes(user.role)) {
      return (
        <span>
          <Link to={`/myadmin/customer/${asistente.customer_id}`}>{name}</Link>
          <span className="ms-1">
            {renderTrialClass()} {renderWellhub()} {renderWhatsAppVerified()}
          </span>
        </span>
      );
    }
    return (
      <span>
        {name} {renderTrialClass()} {renderWellhub()} {renderWhatsAppVerified()}
      </span>
    );
  };

  const renderBirthday = () => {
    if (asistente.birthdate && asistente.birthdate !== null) {
      if (
        moment(asistente.birthdate).utc().format("YYYY-MM-DD") ===
        moment().format("YYYY-MM-DD")
      ) {
        return <i className="fa fa-birthdate-cake"></i>;
      }
    }
  };

  const renderCustomerContact = () => {
    if (
      ["super_admin", "admin", "manager"].includes(user.role) &&
      asistente.customer &&
      asistente.customer !== null
    ) {
      return [
        <td key="instagram">
          <i className="fab fa-instagram me-2"></i>
          {"@"}
          {asistente.customer.instagram}
        </td>,
        <td key="email">
          <i className="fa fa-envelope me-2"></i>
          {asistente.customer.email}
        </td>,
        <td key="whatsapp">
          <button
            className="me-2 btn-sm btn btn-success"
            onClick={() => sendWhatsApp(asistente.customer.phone)}
          >
            <i className="fab fa-whatsapp"></i>
          </button>
          {asistente.customer.phone}
        </td>,
      ];
    }
  };

  const renderCancelButton = () => {
    if (["super_admin", "admin", "manager"].includes(user.role)) {
      return (
        <button
          className="btn btn-sm btn-outline-danger mx-2"
          onClick={() => confirmCancel(asistente)}
        >
          <i className="fa fa-times"></i>
        </button>
      );
    }
  };

  const renderLastNotificationStatus = () => {
    if (notifying) return <div className="spinner-border spinner-border-sm" />;
    const last_notification = getLastNotication();
    if (last_notification && last_notification !== null) {
      const { status, twilio_template_id } = last_notification;
      if (status && status !== null) {
        const colors = {
          sent: "bg-secondary fw-normal",
          failed: "bg-danger fw-normal",
          queued: "bg-secondary fw-normal",
          delivered: "bg-success text-dark",
          undelivered: "bg-danger fw-normal",
        };
        return (
          <div>
            <p className="small mb-0">{templateLabels[twilio_template_id]}</p>
            <span
              className={`badge badge-pill text-capitalize ${colors[status]}`}
            >
              {statusLabels[status]}
            </span>
          </div>
        );
      }
    }
  };

  return (
    <tr className="align-middle small bg-white">
      <td>
        {renderBirthday()}
        {renderCustomer()}
      </td>
      <td>{renderLastNotificationStatus()}</td>
      {renderCustomerContact()}
      {!is_special_event && !is_waitlist && (
        <td>
          {asistente.deletedAt === null ? (
            <>
              <button
                className={`btn btn-sm btn-${
                  !asistente.attend ? "outline-secondary" : "link text-dark"
                } me-2`}
                onClick={() =>
                  postAttend(
                    asistente.class_reservation_id,
                    !asistente.attend,
                    handleCallback
                  )
                }
              >
                <i className="fa fa-check"></i>
              </button>
              {asistente.is_cash && (
                <button
                  className={`btn btn-sm btn-outline-${
                    asistente.is_paid ? "danger" : "success"
                  } mx-2`}
                  onClick={() =>
                    postPayment(
                      asistente.class_reservation_id,
                      !asistente.is_paid,
                      single_class_id
                    )
                  }
                >
                  <i className="fa fa-money-bill"></i>
                </button>
              )}
              {renderCancelButton()}
            </>
          ) : (
            <span className="badge badge-pill bg-danger">Cancelada</span>
          )}
        </td>
      )}
    </tr>
  );
};

export default AsistenteRow;
